function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../Charts.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
import RowChartStacked from './RowChartStacked';
export var RowChartGrouped = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RowChartGrouped, _Component);

  function RowChartGrouped(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_chart", null);

    _this.chartRef = React.createRef();
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.chart = _this.createChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = RowChartGrouped.prototype;

  _proto.createChart = function createChart(parent, chartGroup) {
    var _chart = dc.coordinateGridMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));

    var _g = null;
    var _tile = null;

    _chart.tile = function (tile) {
      if (tile !== undefined) {
        _tile = tile;
        return _chart;
      } else {
        return _tile;
      }
    };

    _chart._draw = function () {
      // Extract and sort group
      var _group = _chart.group().all().slice(0);

      var data = {
        labels: ['resilience', 'maintainability', 'accessibility', 'uptime', 'functionality', 'impact'],
        series: [{
          label: '2012',
          values: [4, 8, 15, 16, 23, 42]
        }, {
          label: '2013',
          values: [12, 43, 22, 11, 73, 25]
        }, {
          label: '2014',
          values: [31, 28, 14, 8, 15, 21]
        }]
      }; // Setup SVG

      _chart.resetSvg();

      _g = _chart.svg().append('g').attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')').attr('class', 'row-chart-grouped');
      var chartWidth = 300,
          barHeight = 20,
          groupHeight = barHeight * data.series.length,
          gapBetweenGroups = 10,
          spaceForLabels = 150,
          spaceForLegend = 150; // Zip the series data together (first values, second values, etc.)

      var zippedData = [];

      for (var i = 0; i < data.labels.length; i++) {
        for (var j = 0; j < data.series.length; j++) {
          zippedData.push(data.series[j].values[i]);
        }
      } // Color scale


      var color = _chart.colors();

      var chartHeight = barHeight * zippedData.length + gapBetweenGroups * data.labels.length;
      var x = d3.scaleLinear().domain([0, d3.max(zippedData)]).range([0, chartWidth]);
      var y = d3.scaleLinear().range([chartHeight + gapBetweenGroups, 0]);
      var yAxis = d3.axisLeft().scale(y).tickFormat('').tickSize(0); // Specify the chart area and dimensions
      // Create bars

      var bar = _g.selectAll('g').data(zippedData).enter().append('g').attr('transform', function (d, i) {
        return 'translate(' + spaceForLabels + ',' + (i * barHeight + gapBetweenGroups * (0.5 + Math.floor(i / data.series.length))) + ')';
      }); // Create rectangles of the correct width


      bar.append('rect').attr('fill', function (d, i) {
        return color(i % data.series.length);
      }).attr('class', 'bar').attr('width', x).attr('height', barHeight - 1); // Add text label in bar

      bar.append('text').attr('x', function (d) {
        return x(d) - 3;
      }).attr('y', barHeight / 2).attr('fill', 'red').attr('dy', '.35em').text(function (d) {
        return d;
      }); // Draw labels

      bar.append('text').attr('class', 'label').attr('x', function (d) {
        return -10;
      }).attr('y', groupHeight / 2).attr('dy', '.35em').text(function (d, i) {
        if (i % data.series.length === 0) return data.labels[Math.floor(i / data.series.length)];else return '';
      });

      _g.append('g').attr('class', 'y axis').attr('transform', 'translate(' + spaceForLabels + ', ' + -gapBetweenGroups / 2 + ')').call(yAxis); // Draw legend


      var legendRectSize = 18,
          legendSpacing = 4;

      var legend = _g.selectAll('.legend').data(data.series).enter().append('g').attr('transform', function (d, i) {
        var height = legendRectSize + legendSpacing;
        var offset = -gapBetweenGroups / 2;
        var horz = spaceForLabels + chartWidth + 40 - legendRectSize;
        var vert = i * height - offset;
        return 'translate(' + horz + ',' + vert + ')';
      });

      legend.append('rect').attr('width', legendRectSize).attr('height', legendRectSize).style('fill', function (d, i) {
        return color(i);
      }).style('stroke', function (d, i) {
        return color(i);
      });
      legend.append('text').attr('class', 'legend').attr('x', legendRectSize + legendSpacing).attr('y', legendRectSize - legendSpacing).text(function (d) {
        return d.label;
      });
    };

    _chart._doRender = function () {
      _chart._draw();
    };

    _chart._doRedraw = function () {
      _chart._draw();
    };

    return _chart.anchor(parent, chartGroup);
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        renderLabel = _this$props.renderLabel,
        renderTitle = _this$props.renderTitle,
        valueAccessor = _this$props.valueAccessor,
        tile = _this$props.tile,
        margins = _this$props.margins;
    this._chart = this.createChart(this.chartRef.current); // Set mixin properties

    BaseMixin(this._chart, this.props);
    ColorMixin(this._chart, this.props);
    MarginsMixin(this._chart, this.props);
    CoordinateGridMixin(this._chart, this.props);
    TileMixin(this._chart, this.props); // Set custom properties

    this._chart.tile(tile).renderLabel(renderLabel).renderTitle(renderTitle).valueAccessor(valueAccessor); // Render chart


    this._chart.render();
  };

  _proto.getChart = function getChart() {
    return this._chart;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart tree-map",
      ref: this.chartRef
    }));
  };

  return RowChartGrouped;
}(Component);

_defineProperty(RowChartGrouped, "defaultProps", {
  width: 640,
  height: 480,
  renderLabel: true,
  renderTitle: true,
  valueAccessor: function valueAccessor(d) {
    return d.value;
  },
  tile: d3.treemapBinary,
  margins: {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }
});

RowChartGrouped.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A Crossfilter dimension made that returns an array key, e.g. crossfilter.dimension(d=>[d.key, d.key2, ..., d.keyN]).
   * The first element in the array will be the top level of the hierarchy */
  dimension: PropTypes.object.isRequired,

  /** A Crossfilter group made on the same dimension */
  group: PropTypes.object.isRequired,

  /** Either an array of colors or a function that accepts a value and returns a color */
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),

  /** Title to render on the chart */
  chartTitle: PropTypes.string,

  /** Width of diagram in pixels */
  width: PropTypes.number,

  /** Height of diagram in pixels */
  height: PropTypes.number,

  /** Render data labels in the diagram */
  renderLabel: PropTypes.bool,

  /** Render SVG:title tag, i.e. "tooltip" labels when holding the mouse above a rectangle */
  renderTitle: PropTypes.bool,

  /** Function to access the value */
  valueAccessor: PropTypes.func,

  /** Tile functions, one of d3.tilemap... functions  */
  tile: PropTypes.func,

  /** Margins object {top, bottom, left, right} */
  margins: PropTypes.object
} : {};
export default RowChartStacked;